<script setup lang="ts">
import { RIcon } from '#atoms'

defineProps<{
  files: {
    label: string
    link: string
  }[]
}>()
</script>

<template>
  <div>
    <slot name="heading"></slot>
    <ul class="flex flex-col gap-2">
      <li v-for="(file, index) in files">
        <a
          class="flex align-center gap-1 text-blue-600 hover:underline"
          :key="index"
          :href="file?.link"
          rel="noopener"
          target="_blank"
        >
          <RIcon
            icon="icon-[ph--download-simple]"
            class="text-l"
            color="var(--p-blue-600)"
          />
          <span class="leading-[19.6px] text-sm">{{ file.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<i18n src="./RBookingDocument.i18n.json"></i18n>
